const AMMFactory = [{
  "type": "constructor",
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "_logic"
  }, {
    "type": "address",
    "name": "admin_"
  }, {
    "type": "bytes",
    "name": "_data"
  }]
}, {
  "type": "event",
  "anonymous": false,
  "name": "AdminChanged",
  "inputs": [{
    "type": "address",
    "name": "previousAdmin"
  }, {
    "type": "address",
    "name": "newAdmin"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "BeaconUpgraded",
  "inputs": [{
    "type": "address",
    "name": "beacon",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Upgraded",
  "inputs": [{
    "type": "address",
    "name": "implementation",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "admin",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address",
    "name": "admin_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "changeAdmin",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newAdmin"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "implementation",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address",
    "name": "implementation_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "upgradeTo",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newImplementation"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "upgradeToAndCall",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "newImplementation"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": []
}];
const BaseRegistrarImplementation = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_ens"
  }, {
    "type": "bytes32",
    "name": "_baseNode"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "approved",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ApprovalForAll",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "operator",
    "indexed": true
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ControllerAdded",
  "inputs": [{
    "type": "address",
    "name": "controller",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ControllerRemoved",
  "inputs": [{
    "type": "address",
    "name": "controller",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NameMigrated",
  "inputs": [{
    "type": "uint256",
    "name": "id",
    "indexed": true
  }, {
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "expires"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NameRegistered",
  "inputs": [{
    "type": "uint256",
    "name": "id",
    "indexed": true
  }, {
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "expires"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NameRenewed",
  "inputs": [{
    "type": "uint256",
    "name": "id",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "expires"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "GRACE_PERIOD",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "addController",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "controller"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "available",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "id"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "baseNode",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bytes32"
  }]
}, {
  "type": "function",
  "name": "controllers",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "ens",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "getApproved",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "isApprovedForAll",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "address",
    "name": "operator"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "isOwner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "nameExpires",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "id"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "ownerOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "reclaim",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "id"
  }, {
    "type": "address",
    "name": "owner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "register",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "id"
  }, {
    "type": "address",
    "name": "owner"
  }, {
    "type": "uint256",
    "name": "duration"
  }],
  "outputs": [{
    "type": "uint256"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "registerOnly",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "id"
  }, {
    "type": "address",
    "name": "owner"
  }, {
    "type": "uint256",
    "name": "duration"
  }],
  "outputs": [{
    "type": "uint256"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "removeController",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "controller"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "renew",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "id"
  }, {
    "type": "uint256",
    "name": "duration"
  }],
  "outputs": [{
    "type": "uint256"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes",
    "name": "_data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setApprovalForAll",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setResolver",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "resolver"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceID"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}];
const CreateVaultZap = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "nftxRouter_"
  }, {
    "type": "address",
    "name": "ammFactory_"
  }, {
    "type": "address",
    "name": "inventoryStaking_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "InsufficientETHSent",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientVTokensMinted",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotNFTOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "R",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "T",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnableToSendETH",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "WETH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "ammFactory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "createVault",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "tuple",
      "name": "vaultInfo",
      "components": [{
        "type": "address",
        "name": "assetAddress"
      }, {
        "type": "bool",
        "name": "is1155"
      }, {
        "type": "bool",
        "name": "allowAllItems"
      }, {
        "type": "string",
        "name": "name"
      }, {
        "type": "string",
        "name": "symbol"
      }]
    }, {
      "type": "tuple",
      "name": "eligibilityStorage",
      "components": [{
        "type": "uint256",
        "name": "moduleIndex"
      }, {
        "type": "bytes",
        "name": "initData"
      }]
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256[]",
      "name": "nftAmounts"
    }, {
      "type": "uint256",
      "name": "vaultFeaturesFlag"
    }, {
      "type": "tuple",
      "name": "vaultFees",
      "components": [{
        "type": "uint256",
        "name": "mintFee"
      }, {
        "type": "uint256",
        "name": "redeemFee"
      }, {
        "type": "uint256",
        "name": "swapFee"
      }]
    }, {
      "type": "tuple",
      "name": "liquidityParams",
      "components": [{
        "type": "uint256",
        "name": "lowerNFTPriceInETH"
      }, {
        "type": "uint256",
        "name": "upperNFTPriceInETH"
      }, {
        "type": "uint24",
        "name": "fee"
      }, {
        "type": "uint256",
        "name": "currentNFTPriceInETH"
      }, {
        "type": "uint256",
        "name": "vTokenMin"
      }, {
        "type": "uint256",
        "name": "wethMin"
      }, {
        "type": "uint256",
        "name": "deadline"
      }]
    }]
  }],
  "outputs": [{
    "type": "uint256",
    "name": "vaultId"
  }]
}, {
  "type": "function",
  "name": "inventoryStaking",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "nftxRouter",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "onERC1155BatchReceived",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256[]"
  }, {
    "type": "uint256[]"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC1155Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "vaultFactory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}];
const CryptoPunks = [{
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "punksOfferedForSale",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "bool",
    "name": "isForSale"
  }, {
    "type": "uint256",
    "name": "punkIndex"
  }, {
    "type": "address",
    "name": "seller"
  }, {
    "type": "uint256",
    "name": "minValue"
  }, {
    "type": "address",
    "name": "onlySellTo"
  }]
}, {
  "type": "function",
  "name": "enterBidForPunk",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "totalSupply",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "acceptBidForPunk",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }, {
    "type": "uint256",
    "name": "minPrice"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "decimals",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint8"
  }]
}, {
  "type": "function",
  "name": "setInitialOwners",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address[]",
    "name": "addresses"
  }, {
    "type": "uint256[]",
    "name": "indices"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "withdraw",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "imageHash",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "nextPunkIndexToAssign",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "punkIndexToAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "standard",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "punkBids",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "bool",
    "name": "hasBid"
  }, {
    "type": "uint256",
    "name": "punkIndex"
  }, {
    "type": "address",
    "name": "bidder"
  }, {
    "type": "uint256",
    "name": "value"
  }]
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "allInitialOwnersAssigned",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "allPunksAssigned",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "buyPunk",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "transferPunk",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "punkIndex"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "symbol",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "withdrawBidForPunk",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setInitialOwner",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "punkIndex"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "offerPunkForSaleToAddress",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }, {
    "type": "uint256",
    "name": "minSalePriceInWei"
  }, {
    "type": "address",
    "name": "toAddress"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "punksRemainingToAssign",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "offerPunkForSale",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }, {
    "type": "uint256",
    "name": "minSalePriceInWei"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "getPunk",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "pendingWithdrawals",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "punkNoLongerForSale",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "constructor",
  "stateMutability": "payable",
  "payable": true,
  "inputs": []
}, {
  "type": "event",
  "anonymous": false,
  "name": "Assign",
  "inputs": [{
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "punkIndex"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PunkTransfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "punkIndex"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PunkOffered",
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "minValue"
  }, {
    "type": "address",
    "name": "toAddress",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PunkBidEntered",
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }, {
    "type": "address",
    "name": "fromAddress",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PunkBidWithdrawn",
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }, {
    "type": "address",
    "name": "fromAddress",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PunkBought",
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }, {
    "type": "address",
    "name": "fromAddress",
    "indexed": true
  }, {
    "type": "address",
    "name": "toAddress",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PunkNoLongerForSale",
  "inputs": [{
    "type": "uint256",
    "name": "punkIndex",
    "indexed": true
  }],
  "stateMutability": "view"
}];
const ERC20 = [{
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "spender",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "allowance",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "address",
    "name": "spender"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "account"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "burn",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "burnFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "account"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "changeName",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "string",
    "name": "name"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "changeSymbol",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "string",
    "name": "symbol"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "decimals",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint8"
  }]
}, {
  "type": "function",
  "name": "decreaseAllowance",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "subtractedValue"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "increaseAllowance",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "addedValue"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "initialize",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "string",
    "name": "name"
  }, {
    "type": "string",
    "name": "symbol"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "mint",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "symbol",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "totalSupply",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "transfer",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "recipient"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "sender"
  }, {
    "type": "address",
    "name": "recipient"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}];
const ERC721 = [{
  "type": "constructor",
  "payable": false,
  "inputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "approved",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ApprovalForAll",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "operator",
    "indexed": true
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "baseURI",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "getApproved",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "isApprovedForAll",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "address",
    "name": "operator"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "mint",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "string",
    "name": "tokenURI"
  }],
  "outputs": [{
    "type": "uint256"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "ownerOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes",
    "name": "_data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setApprovalForAll",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "operator"
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "symbol",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "tokenByIndex",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "index"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "tokenOfOwnerByIndex",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "uint256",
    "name": "index"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "tokenURI",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "totalSupply",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}];
const InventoryStaking = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "WETH_"
  }, {
    "type": "address",
    "name": "PERMIT2_"
  }, {
    "type": "address",
    "name": "nftxVaultFactory_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "ApprovalToCurrentOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientVTokenShares",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientVTokens",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidEarlyWithdrawPenalty",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidSignature",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "LiquidityBelowMinimum",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotGuardian",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotNFTOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotPositionOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ParentChildSame",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "Paused",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "PermitExpired",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "PositionNotCreatedWithVTokens",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "SenderNotFeeDistributor",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TimelockTooLong",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "Timelocked",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnableToSendETH",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "Unauthorized",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "VaultIdMismatch",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroVTokenShares",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "approved",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ApprovalForAll",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "operator",
    "indexed": true
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "CollectWethFees",
  "inputs": [{
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "wethAmount"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "CombinePositions",
  "inputs": [{
    "type": "uint256",
    "name": "parentPositionId"
  }, {
    "type": "uint256[]",
    "name": "childPositionIds"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Deposit",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "amount"
  }, {
    "type": "bool",
    "name": "forceTimelock"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "DepositWithNFT",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256[]",
    "name": "tokenIds"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "IncreasePosition",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Initialized",
  "inputs": [{
    "type": "uint8",
    "name": "version"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "SetIsGuardian",
  "inputs": [{
    "type": "address",
    "name": "addr"
  }, {
    "type": "bool",
    "name": "isGuardian"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "SetPaused",
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }, {
    "type": "bool",
    "name": "paused"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "UpdateEarlyWithdrawPenalty",
  "inputs": [{
    "type": "uint256",
    "name": "newEarlyWithdrawPenaltyInWei"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "UpdateTimelock",
  "inputs": [{
    "type": "uint256",
    "name": "newTimelock"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Withdraw",
  "inputs": [{
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "vTokenShares"
  }, {
    "type": "uint256",
    "name": "vTokenAmount"
  }, {
    "type": "uint256",
    "name": "wethAmount"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "DOMAIN_SEPARATOR",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bytes32"
  }]
}, {
  "type": "function",
  "name": "MINIMUM_LIQUIDITY",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "PERMIT2",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "PERMIT_TYPEHASH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bytes32"
  }]
}, {
  "type": "function",
  "name": "WETH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "__NFTXInventoryStaking_init",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "timelock_"
  }, {
    "type": "uint256",
    "name": "earlyWithdrawPenaltyInWei_"
  }, {
    "type": "address",
    "name": "timelockExcludeList_"
  }, {
    "type": "address",
    "name": "descriptor_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "collectWethFees",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "positionIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "combinePositions",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "parentPositionId"
  }, {
    "type": "uint256[]",
    "name": "childPositionIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "deposit",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "amount"
  }, {
    "type": "address",
    "name": "recipient"
  }, {
    "type": "bytes",
    "name": "encodedPermit2"
  }, {
    "type": "bool",
    "name": "viaPermit2"
  }, {
    "type": "bool",
    "name": "forceTimelock"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "positionId"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "depositWithNFT",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "tokenIds"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "address",
    "name": "recipient"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "positionId"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "descriptor",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "earlyWithdrawPenaltyInWei",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "getApproved",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "increasePosition",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "positionId"
  }, {
    "type": "uint256",
    "name": "amount"
  }, {
    "type": "bytes",
    "name": "encodedPermit2"
  }, {
    "type": "bool",
    "name": "viaPermit2"
  }, {
    "type": "bool",
    "name": "forceTimelock"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "isApprovedForAll",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "address",
    "name": "operator"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "isGuardian",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "isPaused",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "nftxVaultFactory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "onERC1155BatchReceived",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256[]"
  }, {
    "type": "uint256[]"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC1155Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onlyOwnerIfPaused",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "ownerOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "pause",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "permit",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "uint256",
    "name": "deadline"
  }, {
    "type": "uint8",
    "name": "v"
  }, {
    "type": "bytes32",
    "name": "r"
  }, {
    "type": "bytes32",
    "name": "s"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "positions",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "nonce"
  }, {
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "timelockedUntil"
  }, {
    "type": "uint256",
    "name": "timelock"
  }, {
    "type": "uint256",
    "name": "vTokenTimelockedUntil"
  }, {
    "type": "uint256",
    "name": "vTokenShareBalance"
  }, {
    "type": "uint256",
    "name": "wethFeesPerVTokenShareSnapshotX128"
  }, {
    "type": "uint256",
    "name": "wethOwed"
  }]
}, {
  "type": "function",
  "name": "pricePerShareVToken",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "receiveWethRewards",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "wethAmount"
  }],
  "outputs": [{
    "type": "bool",
    "name": "rewardsDistributed"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setApprovalForAll",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "operator"
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setDescriptor",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "descriptor_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setEarlyWithdrawPenalty",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "earlyWithdrawPenaltyInWei_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setIsGuardian",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "addr"
  }, {
    "type": "bool",
    "name": "_isGuardian"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setTimelock",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "timelock_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "symbol",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "timelock",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "timelockExcludeList",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "tokenByIndex",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "index"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "tokenOfOwnerByIndex",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "uint256",
    "name": "index"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "tokenURI",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "totalSupply",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "unpause",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "vaultGlobal",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "totalVTokenShares"
  }, {
    "type": "uint256",
    "name": "globalWethFeesPerVTokenShareX128"
  }]
}, {
  "type": "function",
  "name": "wethBalance",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "positionId"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "withdraw",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "positionId"
  }, {
    "type": "uint256",
    "name": "vTokenShares"
  }, {
    "type": "uint256[]",
    "name": "nftIds"
  }, {
    "type": "uint256",
    "name": "vTokenPremiumLimit"
  }],
  "outputs": []
}];
const KittyCore = [{
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "_interfaceID"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "cfoAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "tokenMetadata",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_tokenId"
  }, {
    "type": "string",
    "name": "_preferredTransport"
  }],
  "outputs": [{
    "type": "string",
    "name": "infoUrl"
  }]
}, {
  "type": "function",
  "name": "promoCreatedCount",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_to"
  }, {
    "type": "uint256",
    "name": "_tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "ceoAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "GEN0_STARTING_PRICE",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "setSiringAuctionAddress",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_address"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "totalSupply",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "pregnantKitties",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "isPregnant",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_kittyId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "GEN0_AUCTION_DURATION",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "siringAuction",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_from"
  }, {
    "type": "address",
    "name": "_to"
  }, {
    "type": "uint256",
    "name": "_tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setGeneScienceAddress",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_address"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setCEO",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_newCEO"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setCOO",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_newCOO"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "createSaleAuction",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_kittyId"
  }, {
    "type": "uint256",
    "name": "_startingPrice"
  }, {
    "type": "uint256",
    "name": "_endingPrice"
  }, {
    "type": "uint256",
    "name": "_duration"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "unpause",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "sireAllowedToAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "canBreedWith",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_matronId"
  }, {
    "type": "uint256",
    "name": "_sireId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "kittyIndexToApproved",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "createSiringAuction",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_kittyId"
  }, {
    "type": "uint256",
    "name": "_startingPrice"
  }, {
    "type": "uint256",
    "name": "_endingPrice"
  }, {
    "type": "uint256",
    "name": "_duration"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setAutoBirthFee",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "val"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "approveSiring",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_addr"
  }, {
    "type": "uint256",
    "name": "_sireId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setCFO",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_newCFO"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "createPromoKitty",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_genes"
  }, {
    "type": "address",
    "name": "_owner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setSecondsPerBlock",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "secs"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "paused",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "withdrawBalance",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "ownerOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_tokenId"
  }],
  "outputs": [{
    "type": "address",
    "name": "owner"
  }]
}, {
  "type": "function",
  "name": "GEN0_CREATION_LIMIT",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "newContractAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "setSaleAuctionAddress",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_address"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_owner"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "count"
  }]
}, {
  "type": "function",
  "name": "setNewAddress",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_v2Address"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "secondsPerBlock",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "pause",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "tokensOfOwner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_owner"
  }],
  "outputs": [{
    "type": "uint256[]",
    "name": "ownerTokens"
  }]
}, {
  "type": "function",
  "name": "giveBirth",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_matronId"
  }],
  "outputs": [{
    "type": "uint256"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "withdrawAuctionBalances",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "symbol",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "cooldowns",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint32"
  }]
}, {
  "type": "function",
  "name": "kittyIndexToOwner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "transfer",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_to"
  }, {
    "type": "uint256",
    "name": "_tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "cooAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "autoBirthFee",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "erc721Metadata",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "createGen0Auction",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_genes"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "isReadyToBreed",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_kittyId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "PROMO_CREATION_LIMIT",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "setMetadataAddress",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_contractAddress"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "saleAuction",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "getKitty",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_id"
  }],
  "outputs": [{
    "type": "bool",
    "name": "isGestating"
  }, {
    "type": "bool",
    "name": "isReady"
  }, {
    "type": "uint256",
    "name": "cooldownIndex"
  }, {
    "type": "uint256",
    "name": "nextActionAt"
  }, {
    "type": "uint256",
    "name": "siringWithId"
  }, {
    "type": "uint256",
    "name": "birthTime"
  }, {
    "type": "uint256",
    "name": "matronId"
  }, {
    "type": "uint256",
    "name": "sireId"
  }, {
    "type": "uint256",
    "name": "generation"
  }, {
    "type": "uint256",
    "name": "genes"
  }]
}, {
  "type": "function",
  "name": "bidOnSiringAuction",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "_sireId"
  }, {
    "type": "uint256",
    "name": "_matronId"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "gen0CreatedCount",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "geneScience",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "breedWithAuto",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "_matronId"
  }, {
    "type": "uint256",
    "name": "_sireId"
  }],
  "outputs": []
}, {
  "type": "constructor",
  "payable": false,
  "inputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Pregnant",
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "uint256",
    "name": "matronId"
  }, {
    "type": "uint256",
    "name": "sireId"
  }, {
    "type": "uint256",
    "name": "cooldownEndBlock"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "address",
    "name": "approved"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Birth",
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "uint256",
    "name": "kittyId"
  }, {
    "type": "uint256",
    "name": "matronId"
  }, {
    "type": "uint256",
    "name": "sireId"
  }, {
    "type": "uint256",
    "name": "genes"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ContractUpgrade",
  "inputs": [{
    "type": "address",
    "name": "newContract"
  }],
  "stateMutability": "view"
}];
const MarketplaceZap = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "nftxVaultFactory_"
  }, {
    "type": "address",
    "name": "universalRouter_"
  }, {
    "type": "address",
    "name": "PERMIT2_"
  }, {
    "type": "address",
    "name": "inventoryStaking_"
  }, {
    "type": "address",
    "name": "WETH_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "InsufficientWethForVaultFees",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotEnoughFundsForRedeem",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotNFTOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "SwapFailed",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnableToSendETH",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "WrongVaultType",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZapPaused",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Buy",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "nftIds"
  }, {
    "type": "uint256",
    "name": "ethSpent"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "netRoyaltyAmount"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "DustReturned",
  "inputs": [{
    "type": "uint256",
    "name": "ethAmount"
  }, {
    "type": "uint256",
    "name": "vTokenAmount"
  }, {
    "type": "address",
    "name": "to"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewDustThreshold",
  "inputs": [{
    "type": "uint256",
    "name": "dustThreshold"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewUniversalRouter",
  "inputs": [{
    "type": "address",
    "name": "universalRouter"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Paused",
  "inputs": [{
    "type": "bool",
    "name": "status"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Sell",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "count"
  }, {
    "type": "uint256",
    "name": "ethReceived"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "netRoyaltyAmount"
  }, {
    "type": "uint256",
    "name": "wethFees"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Swap",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "idsIn"
  }, {
    "type": "uint256[]",
    "name": "idsOut"
  }, {
    "type": "uint256",
    "name": "ethSpent"
  }, {
    "type": "address",
    "name": "to"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Swap",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "idsIn"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "uint256[]",
    "name": "idsOut"
  }, {
    "type": "uint256",
    "name": "ethSpent"
  }, {
    "type": "address",
    "name": "to"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "PERMIT2",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "WETH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "buyNFTsWithERC20",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "address",
      "name": "tokenIn"
    }, {
      "type": "uint256",
      "name": "amountIn"
    }, {
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256[]",
      "name": "idsOut"
    }, {
      "type": "uint256",
      "name": "vTokenPremiumLimit"
    }, {
      "type": "bytes",
      "name": "executeToWETHCallData"
    }, {
      "type": "bytes",
      "name": "executeToVTokenCallData"
    }, {
      "type": "address",
      "name": "to"
    }, {
      "type": "bool",
      "name": "deductRoyalty"
    }]
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "buyNFTsWithERC20WithPermit2",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "address",
      "name": "tokenIn"
    }, {
      "type": "uint256",
      "name": "amountIn"
    }, {
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256[]",
      "name": "idsOut"
    }, {
      "type": "uint256",
      "name": "vTokenPremiumLimit"
    }, {
      "type": "bytes",
      "name": "executeToWETHCallData"
    }, {
      "type": "bytes",
      "name": "executeToVTokenCallData"
    }, {
      "type": "address",
      "name": "to"
    }, {
      "type": "bool",
      "name": "deductRoyalty"
    }]
  }, {
    "type": "bytes",
    "name": "encodedPermit2"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "buyNFTsWithETH",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "idsOut"
  }, {
    "type": "bytes",
    "name": "executeCallData"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "vTokenPremiumLimit"
  }, {
    "type": "bool",
    "name": "deductRoyalty"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "dustThreshold",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "inventoryStaking",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "nftxVaultFactory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "onERC1155BatchReceived",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256[]"
  }, {
    "type": "uint256[]"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC1155Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC721Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "pause",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "bool",
    "name": "paused_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "paused",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "sell1155",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "idsIn"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "bytes",
    "name": "executeCallData"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "bool",
    "name": "deductRoyalty"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "sell721",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "idsIn"
  }, {
    "type": "bytes",
    "name": "executeCallData"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "bool",
    "name": "deductRoyalty"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setDustThreshold",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "dustThreshold_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setUniversalRouter",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "universalRouter_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "swap1155",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "idsIn"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "uint256[]",
    "name": "idsOut"
  }, {
    "type": "uint256",
    "name": "vTokenPremiumLimit"
  }, {
    "type": "address",
    "name": "to"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "swap721",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256[]",
    "name": "idsIn"
  }, {
    "type": "uint256[]",
    "name": "idsOut"
  }, {
    "type": "uint256",
    "name": "vTokenPremiumLimit"
  }, {
    "type": "address",
    "name": "to"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "universalRouter",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}];
const NFTXENSMerkleEligibility = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "_minExpirationTime"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NFTXEligibilityInit",
  "inputs": [{
    "type": "bytes32",
    "name": "merkleRoot"
  }, {
    "type": "string",
    "name": "_merkleReference"
  }, {
    "type": "string",
    "name": "_merkleLeavesURI"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PrecursoryCheckComplete",
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes32",
    "name": "requestId"
  }, {
    "type": "bool",
    "name": "isValid"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PrecursoryCheckStarted",
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes32",
    "name": "requestId"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "__NFTXEligibility_init",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "bytes32",
    "name": "_merkleRoot"
  }, {
    "type": "string",
    "name": "_merkleReference"
  }, {
    "type": "string",
    "name": "_merkleLeavesURI"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "__NFTXEligibility_init_bytes",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "bytes",
    "name": "configData"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "afterMintHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "afterRedeemHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "beforeMintHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "beforeRedeemHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "checkAllEligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "checkAllIneligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "checkEligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [{
    "type": "bool[]"
  }]
}, {
  "type": "function",
  "name": "checkIsEligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "finalized",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "merkleLeavesURI",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "merkleReference",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "merkleRoot",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bytes32"
  }]
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "processToken",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes32[]",
    "name": "merkleProof"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "processTokens",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }, {
    "type": "bytes32[][]",
    "name": "merkleProofs"
  }],
  "outputs": [{
    "type": "bool[]"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "requiresProcessing",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes32[]",
    "name": "merkleProof"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "targetAsset",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "validTokenHashes",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes32"
  }],
  "outputs": [{
    "type": "bool"
  }]
}];
const NFTXEligibility = [{
  "type": "function",
  "name": "__NFTXEligibility_init_bytes",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "bytes",
    "name": "initData"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "afterMintHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "afterRedeemHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "beforeMintHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "beforeRedeemHook",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "checkAllEligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "checkAllIneligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "checkEligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [{
    "type": "bool[]"
  }]
}, {
  "type": "function",
  "name": "checkIsEligible",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "finalized",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "targetAsset",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}];
const NFTXVaultUpgradeable = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "WETH_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "AmountExceedsMaxFlashLoan",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ApproveFromZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ApproveToZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "BurnAmountExceedsBalance",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "BurnFromZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "CallerIsNotTheOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "CantRescueAssetToken",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "DecreasedAllowanceBelowZero",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ETHSent",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "EligibilityAlreadySet",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "HoldingsUpdationFailed",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "IdNotFound",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientAllowance",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientETHSent",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidReturnValue",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidToken",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "MintToZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "MintingDisabled",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NFTAlreadyOwned",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NewOwnerIsZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotEligible",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotManager",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotNFTOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "Paused",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "PremiumLimitExceeded",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "RedeemDisabled",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "SwapDisabled",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TokenLengthMismatch",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TooManyItems",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TransferAmountExceedsBalance",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TransferAmountIsZero",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TransferFromZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TransferToZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnableToSendETH",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "WrongToken",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "spender",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "EligibilityDeployed",
  "inputs": [{
    "type": "uint256",
    "name": "moduleIndex"
  }, {
    "type": "address",
    "name": "eligibilityAddr"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "EnableMintUpdated",
  "inputs": [{
    "type": "bool",
    "name": "enabled"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "EnableRedeemUpdated",
  "inputs": [{
    "type": "bool",
    "name": "enabled"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "EnableSwapUpdated",
  "inputs": [{
    "type": "bool",
    "name": "enabled"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "FeesDistributed",
  "inputs": [{
    "type": "uint256",
    "name": "wethFees"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Initialized",
  "inputs": [{
    "type": "uint8",
    "name": "version"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ManagerSet",
  "inputs": [{
    "type": "address",
    "name": "manager"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "MetadataUpdated",
  "inputs": [{
    "type": "string",
    "name": "name"
  }, {
    "type": "string",
    "name": "symbol"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Minted",
  "inputs": [{
    "type": "uint256[]",
    "name": "nftIds"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "address",
    "name": "depositor"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "PremiumShared",
  "inputs": [{
    "type": "address",
    "name": "depositor"
  }, {
    "type": "uint256",
    "name": "wethPremium"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Redeemed",
  "inputs": [{
    "type": "uint256[]",
    "name": "specificIds"
  }, {
    "type": "address",
    "name": "to"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Swapped",
  "inputs": [{
    "type": "uint256[]",
    "name": "nftIds"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "uint256[]",
    "name": "specificIds"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "address",
    "name": "depositor"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "value"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "VaultInit",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId",
    "indexed": true
  }, {
    "type": "address",
    "name": "assetAddress"
  }, {
    "type": "bool",
    "name": "is1155"
  }, {
    "type": "bool",
    "name": "allowAllItems"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "VaultShutdown",
  "inputs": [{
    "type": "address",
    "name": "assetAddress"
  }, {
    "type": "uint256",
    "name": "numItems"
  }, {
    "type": "address",
    "name": "recipient"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "WETH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "__NFTXVault_init",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "string",
    "name": "name_"
  }, {
    "type": "string",
    "name": "symbol_"
  }, {
    "type": "address",
    "name": "assetAddress_"
  }, {
    "type": "bool",
    "name": "is1155_"
  }, {
    "type": "bool",
    "name": "allowAllItems_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "allHoldings",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256[]"
  }]
}, {
  "type": "function",
  "name": "allValidNFTs",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "allowAllItems",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "allowance",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "address",
    "name": "spender"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "assetAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "account"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "decimals",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint8"
  }]
}, {
  "type": "function",
  "name": "decreaseAllowance",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "subtractedValue"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "deployEligibilityStorage",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "moduleIndex"
  }, {
    "type": "bytes",
    "name": "initData"
  }],
  "outputs": [{
    "type": "address"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "depositInfo1155",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }, {
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "qty"
  }, {
    "type": "address",
    "name": "depositor"
  }, {
    "type": "uint48",
    "name": "timestamp"
  }]
}, {
  "type": "function",
  "name": "depositInfo1155Length",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "disableVaultFees",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "eligibilityStorage",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "enableMint",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "enableRedeem",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "enableSwap",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "finalizeVault",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "flashFee",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "flashLoan",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "receiver"
  }, {
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256",
    "name": "amount"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "holdingsContains",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "increaseAllowance",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "addedValue"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "is1155",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "manager",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "maxFlashLoan",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "token"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "mint",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256[]",
    "name": "tokenIds"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "address",
    "name": "depositor"
  }, {
    "type": "address",
    "name": "to"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "vTokensMinted"
  }]
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "nftIdAt",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "holdingsIndex"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "onERC1155BatchReceived",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256[]"
  }, {
    "type": "uint256[]"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC1155Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC721Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "pointerIndex1155",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "redeem",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256[]",
    "name": "idsOut"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "wethAmount"
  }, {
    "type": "uint256",
    "name": "vTokenPremiumLimit"
  }, {
    "type": "bool",
    "name": "forceFees"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "ethFees"
  }]
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "rescueTokens",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint8",
    "name": "tt"
  }, {
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256[]",
    "name": "ids"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setFees",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "mintFee_"
  }, {
    "type": "uint256",
    "name": "redeemFee_"
  }, {
    "type": "uint256",
    "name": "swapFee_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setManager",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "manager_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setVaultFeatures",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "bool",
    "name": "enableMint_"
  }, {
    "type": "bool",
    "name": "enableRedeem_"
  }, {
    "type": "bool",
    "name": "enableSwap_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setVaultMetadata",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "string",
    "name": "name_"
  }, {
    "type": "string",
    "name": "symbol_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "shutdown",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "recipient"
  }, {
    "type": "uint256[]",
    "name": "tokenIds"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "swap",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256[]",
    "name": "idsIn"
  }, {
    "type": "uint256[]",
    "name": "amounts"
  }, {
    "type": "uint256[]",
    "name": "idsOut"
  }, {
    "type": "address",
    "name": "depositor"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "vTokenPremiumLimit"
  }, {
    "type": "bool",
    "name": "forceFees"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "ethFees"
  }]
}, {
  "type": "function",
  "name": "symbol",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "tokenDepositInfo",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint48",
    "name": "timestamp"
  }, {
    "type": "address",
    "name": "depositor"
  }]
}, {
  "type": "function",
  "name": "totalHoldings",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "totalSupply",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "transfer",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "bool"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "vTokenToETH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vTokenAmount"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "ethAmount"
  }]
}, {
  "type": "function",
  "name": "vaultFactory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "vaultFees",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256",
    "name": "mintFee"
  }, {
    "type": "uint256",
    "name": "redeemFee"
  }, {
    "type": "uint256",
    "name": "swapFee"
  }]
}, {
  "type": "function",
  "name": "vaultId",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "version",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}];
const NftxRouter = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "address",
      "name": "permit2"
    }, {
      "type": "address",
      "name": "weth9"
    }, {
      "type": "address",
      "name": "seaportV1_5"
    }, {
      "type": "address",
      "name": "seaportV1_4"
    }, {
      "type": "address",
      "name": "openseaConduit"
    }, {
      "type": "address",
      "name": "nftxZap"
    }, {
      "type": "address",
      "name": "x2y2"
    }, {
      "type": "address",
      "name": "foundation"
    }, {
      "type": "address",
      "name": "sudoswap"
    }, {
      "type": "address",
      "name": "elementMarket"
    }, {
      "type": "address",
      "name": "nft20Zap"
    }, {
      "type": "address",
      "name": "cryptopunks"
    }, {
      "type": "address",
      "name": "looksRareV2"
    }, {
      "type": "address",
      "name": "routerRewardsDistributor"
    }, {
      "type": "address",
      "name": "looksRareRewardsDistributor"
    }, {
      "type": "address",
      "name": "looksRareToken"
    }, {
      "type": "address",
      "name": "v2Factory"
    }, {
      "type": "address",
      "name": "v3Factory"
    }, {
      "type": "bytes32",
      "name": "pairInitCodeHash"
    }, {
      "type": "bytes32",
      "name": "poolInitCodeHash"
    }]
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "BalanceTooLow",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "BuyPunkFailed",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ContractLocked",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ETHNotAccepted",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ExecutionFailed",
  "inputs": [{
    "type": "uint256",
    "name": "commandIndex"
  }, {
    "type": "bytes",
    "name": "message"
  }],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "FromAddressIsNotOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientETH",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientToken",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidBips",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidCommandType",
  "inputs": [{
    "type": "uint256",
    "name": "commandType"
  }],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidOwnerERC1155",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidOwnerERC721",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidPath",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidReserves",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidSpender",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "LengthMismatch",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "SliceOutOfBounds",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TransactionDeadlinePassed",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnableToClaim",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnsafeCast",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V2InvalidPath",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V2TooLittleReceived",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V2TooMuchRequested",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3InvalidAmountOut",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3InvalidCaller",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3InvalidSwap",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3TooLittleReceived",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3TooMuchRequested",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "RewardsSent",
  "inputs": [{
    "type": "uint256",
    "name": "amount"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "collectRewards",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "bytes",
    "name": "looksRareClaim"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "execute",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "bytes",
    "name": "commands"
  }, {
    "type": "bytes[]",
    "name": "inputs"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "execute",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "bytes",
    "name": "commands"
  }, {
    "type": "bytes[]",
    "name": "inputs"
  }, {
    "type": "uint256",
    "name": "deadline"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "onERC1155BatchReceived",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256[]"
  }, {
    "type": "uint256[]"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }]
}, {
  "type": "function",
  "name": "onERC1155Received",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }]
}, {
  "type": "function",
  "name": "onERC721Received",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }]
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "uniswapV3SwapCallback",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "int256",
    "name": "amount0Delta"
  }, {
    "type": "int256",
    "name": "amount1Delta"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}];
const NonfungiblePositionManager = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "_factory"
  }, {
    "type": "address",
    "name": "_WETH9"
  }, {
    "type": "address",
    "name": "_tokenDescriptor_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "T",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "approved",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "ApprovalForAll",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "operator",
    "indexed": true
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Collect",
  "inputs": [{
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }, {
    "type": "address",
    "name": "recipient"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "DecreaseLiquidity",
  "inputs": [{
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }, {
    "type": "uint128",
    "name": "liquidity"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "IncreaseLiquidity",
  "inputs": [{
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }, {
    "type": "uint128",
    "name": "liquidity"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Transfer",
  "inputs": [{
    "type": "address",
    "name": "from",
    "indexed": true
  }, {
    "type": "address",
    "name": "to",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "tokenId",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "DOMAIN_SEPARATOR",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bytes32"
  }]
}, {
  "type": "function",
  "name": "PERMIT_TYPEHASH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bytes32"
  }]
}, {
  "type": "function",
  "name": "WETH9",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "balanceOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "baseURI",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "burn",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "collect",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "tokenId"
    }, {
      "type": "address",
      "name": "recipient"
    }, {
      "type": "uint128",
      "name": "amount0Max"
    }, {
      "type": "uint128",
      "name": "amount1Max"
    }]
  }],
  "outputs": [{
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }]
}, {
  "type": "function",
  "name": "createAndInitializePoolIfNecessary",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "token0"
  }, {
    "type": "address",
    "name": "token1"
  }, {
    "type": "uint24",
    "name": "fee"
  }, {
    "type": "uint160",
    "name": "sqrtPriceX96"
  }],
  "outputs": [{
    "type": "address",
    "name": "pool"
  }]
}, {
  "type": "function",
  "name": "decreaseLiquidity",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "tokenId"
    }, {
      "type": "uint128",
      "name": "liquidity"
    }, {
      "type": "uint256",
      "name": "amount0Min"
    }, {
      "type": "uint256",
      "name": "amount1Min"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }],
  "outputs": [{
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }]
}, {
  "type": "function",
  "name": "factory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "getApproved",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "increaseLiquidity",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "tokenId"
    }, {
      "type": "uint256",
      "name": "amount0Desired"
    }, {
      "type": "uint256",
      "name": "amount1Desired"
    }, {
      "type": "uint256",
      "name": "amount0Min"
    }, {
      "type": "uint256",
      "name": "amount1Min"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }],
  "outputs": [{
    "type": "uint128",
    "name": "liquidity"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }]
}, {
  "type": "function",
  "name": "isApprovedForAll",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "address",
    "name": "operator"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "lockedUntil",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "mint",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "address",
      "name": "token0"
    }, {
      "type": "address",
      "name": "token1"
    }, {
      "type": "uint24",
      "name": "fee"
    }, {
      "type": "int24",
      "name": "tickLower"
    }, {
      "type": "int24",
      "name": "tickUpper"
    }, {
      "type": "uint256",
      "name": "amount0Desired"
    }, {
      "type": "uint256",
      "name": "amount1Desired"
    }, {
      "type": "uint256",
      "name": "amount0Min"
    }, {
      "type": "uint256",
      "name": "amount1Min"
    }, {
      "type": "address",
      "name": "recipient"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }],
  "outputs": [{
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "uint128",
    "name": "liquidity"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }]
}, {
  "type": "function",
  "name": "multicall",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "bytes[]",
    "name": "data"
  }],
  "outputs": [{
    "type": "bytes[]",
    "name": "results"
  }]
}, {
  "type": "function",
  "name": "name",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "ownerOf",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "permit",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "uint256",
    "name": "deadline"
  }, {
    "type": "uint8",
    "name": "v"
  }, {
    "type": "bytes32",
    "name": "r"
  }, {
    "type": "bytes32",
    "name": "s"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "positions",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "uint96",
    "name": "nonce"
  }, {
    "type": "address",
    "name": "operator"
  }, {
    "type": "address",
    "name": "token0"
  }, {
    "type": "address",
    "name": "token1"
  }, {
    "type": "uint24",
    "name": "fee"
  }, {
    "type": "int24",
    "name": "tickLower"
  }, {
    "type": "int24",
    "name": "tickUpper"
  }, {
    "type": "uint128",
    "name": "liquidity"
  }, {
    "type": "uint256",
    "name": "feeGrowthInside0LastX128"
  }, {
    "type": "uint256",
    "name": "feeGrowthInside1LastX128"
  }, {
    "type": "uint128",
    "name": "tokensOwed0"
  }, {
    "type": "uint128",
    "name": "tokensOwed1"
  }]
}, {
  "type": "function",
  "name": "refundETH",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [],
  "outputs": []
}, {
  "type": "function",
  "name": "refundETH",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "receiver"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "safeTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "bytes",
    "name": "_data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "selfPermit",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256",
    "name": "value"
  }, {
    "type": "uint256",
    "name": "deadline"
  }, {
    "type": "uint8",
    "name": "v"
  }, {
    "type": "bytes32",
    "name": "r"
  }, {
    "type": "bytes32",
    "name": "s"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "selfPermitAllowed",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256",
    "name": "nonce"
  }, {
    "type": "uint256",
    "name": "expiry"
  }, {
    "type": "uint8",
    "name": "v"
  }, {
    "type": "bytes32",
    "name": "r"
  }, {
    "type": "bytes32",
    "name": "s"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "selfPermitAllowedIfNecessary",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256",
    "name": "nonce"
  }, {
    "type": "uint256",
    "name": "expiry"
  }, {
    "type": "uint8",
    "name": "v"
  }, {
    "type": "bytes32",
    "name": "r"
  }, {
    "type": "bytes32",
    "name": "s"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "selfPermitIfNecessary",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256",
    "name": "value"
  }, {
    "type": "uint256",
    "name": "deadline"
  }, {
    "type": "uint8",
    "name": "v"
  }, {
    "type": "bytes32",
    "name": "r"
  }, {
    "type": "bytes32",
    "name": "s"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "setApprovalForAll",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "operator"
  }, {
    "type": "bool",
    "name": "approved"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setLockedUntil",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "uint256",
    "name": "lockedUntil_"
  }, {
    "type": "uint256",
    "name": "timelock_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setTimelockExcluded",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "addr"
  }, {
    "type": "bool",
    "name": "isExcluded"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "sweepToken",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "uint256",
    "name": "amountMinimum"
  }, {
    "type": "address",
    "name": "recipient"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "symbol",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "timelock",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "timelockExcluded",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "tokenByIndex",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "index"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "tokenOfOwnerByIndex",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "uint256",
    "name": "index"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "tokenURI",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "string"
  }]
}, {
  "type": "function",
  "name": "totalSupply",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "uniswapV3MintCallback",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "amount0Owed"
  }, {
    "type": "uint256",
    "name": "amount1Owed"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "unwrapWETH9",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "uint256",
    "name": "amountMinimum"
  }, {
    "type": "address",
    "name": "recipient"
  }],
  "outputs": []
}];
const Permit2 = [{
  "type": "error",
  "name": "AllowanceExpired",
  "inputs": [{
    "type": "uint256",
    "name": "deadline"
  }],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ExcessiveInvalidation",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientAllowance",
  "inputs": [{
    "type": "uint256",
    "name": "amount"
  }],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidAmount",
  "inputs": [{
    "type": "uint256",
    "name": "maxAmount"
  }],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidContractSignature",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidNonce",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidSignature",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidSignatureLength",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidSigner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "LengthMismatch",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "SignatureExpired",
  "inputs": [{
    "type": "uint256",
    "name": "signatureDeadline"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Approval",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "token",
    "indexed": true
  }, {
    "type": "address",
    "name": "spender",
    "indexed": true
  }, {
    "type": "uint160",
    "name": "amount"
  }, {
    "type": "uint48",
    "name": "expiration"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Lockdown",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "token"
  }, {
    "type": "address",
    "name": "spender"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NonceInvalidation",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "token",
    "indexed": true
  }, {
    "type": "address",
    "name": "spender",
    "indexed": true
  }, {
    "type": "uint48",
    "name": "newNonce"
  }, {
    "type": "uint48",
    "name": "oldNonce"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Permit",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "token",
    "indexed": true
  }, {
    "type": "address",
    "name": "spender",
    "indexed": true
  }, {
    "type": "uint160",
    "name": "amount"
  }, {
    "type": "uint48",
    "name": "expiration"
  }, {
    "type": "uint48",
    "name": "nonce"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "UnorderedNonceInvalidation",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "word"
  }, {
    "type": "uint256",
    "name": "mask"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "DOMAIN_SEPARATOR",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "bytes32"
  }]
}, {
  "type": "function",
  "name": "allowance",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "address"
  }],
  "outputs": [{
    "type": "uint160",
    "name": "amount"
  }, {
    "type": "uint48",
    "name": "expiration"
  }, {
    "type": "uint48",
    "name": "nonce"
  }]
}, {
  "type": "function",
  "name": "approve",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint160",
    "name": "amount"
  }, {
    "type": "uint48",
    "name": "expiration"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "invalidateNonces",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "token"
  }, {
    "type": "address",
    "name": "spender"
  }, {
    "type": "uint48",
    "name": "newNonce"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "invalidateUnorderedNonces",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "wordPos"
  }, {
    "type": "uint256",
    "name": "mask"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "lockdown",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple[]",
    "name": "approvals",
    "components": [{
      "type": "address",
      "name": "token"
    }, {
      "type": "address",
      "name": "spender"
    }]
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "nonceBitmap",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "permit",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "tuple",
    "name": "permitBatch",
    "components": [{
      "type": "tuple[]",
      "name": "details",
      "components": [{
        "type": "address",
        "name": "token"
      }, {
        "type": "uint160",
        "name": "amount"
      }, {
        "type": "uint48",
        "name": "expiration"
      }, {
        "type": "uint48",
        "name": "nonce"
      }]
    }, {
      "type": "address",
      "name": "spender"
    }, {
      "type": "uint256",
      "name": "sigDeadline"
    }]
  }, {
    "type": "bytes",
    "name": "signature"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "permit",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "owner"
  }, {
    "type": "tuple",
    "name": "permitSingle",
    "components": [{
      "type": "tuple",
      "name": "details",
      "components": [{
        "type": "address",
        "name": "token"
      }, {
        "type": "uint160",
        "name": "amount"
      }, {
        "type": "uint48",
        "name": "expiration"
      }, {
        "type": "uint48",
        "name": "nonce"
      }]
    }, {
      "type": "address",
      "name": "spender"
    }, {
      "type": "uint256",
      "name": "sigDeadline"
    }]
  }, {
    "type": "bytes",
    "name": "signature"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "permitTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "permit",
    "components": [{
      "type": "tuple",
      "name": "permitted",
      "components": [{
        "type": "address",
        "name": "token"
      }, {
        "type": "uint256",
        "name": "amount"
      }]
    }, {
      "type": "uint256",
      "name": "nonce"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }, {
    "type": "tuple",
    "name": "transferDetails",
    "components": [{
      "type": "address",
      "name": "to"
    }, {
      "type": "uint256",
      "name": "requestedAmount"
    }]
  }, {
    "type": "address",
    "name": "owner"
  }, {
    "type": "bytes",
    "name": "signature"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "permitTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "permit",
    "components": [{
      "type": "tuple[]",
      "name": "permitted",
      "components": [{
        "type": "address",
        "name": "token"
      }, {
        "type": "uint256",
        "name": "amount"
      }]
    }, {
      "type": "uint256",
      "name": "nonce"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }, {
    "type": "tuple[]",
    "name": "transferDetails",
    "components": [{
      "type": "address",
      "name": "to"
    }, {
      "type": "uint256",
      "name": "requestedAmount"
    }]
  }, {
    "type": "address",
    "name": "owner"
  }, {
    "type": "bytes",
    "name": "signature"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "permitWitnessTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "permit",
    "components": [{
      "type": "tuple",
      "name": "permitted",
      "components": [{
        "type": "address",
        "name": "token"
      }, {
        "type": "uint256",
        "name": "amount"
      }]
    }, {
      "type": "uint256",
      "name": "nonce"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }, {
    "type": "tuple",
    "name": "transferDetails",
    "components": [{
      "type": "address",
      "name": "to"
    }, {
      "type": "uint256",
      "name": "requestedAmount"
    }]
  }, {
    "type": "address",
    "name": "owner"
  }, {
    "type": "bytes32",
    "name": "witness"
  }, {
    "type": "string",
    "name": "witnessTypeString"
  }, {
    "type": "bytes",
    "name": "signature"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "permitWitnessTransferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "permit",
    "components": [{
      "type": "tuple[]",
      "name": "permitted",
      "components": [{
        "type": "address",
        "name": "token"
      }, {
        "type": "uint256",
        "name": "amount"
      }]
    }, {
      "type": "uint256",
      "name": "nonce"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }, {
    "type": "tuple[]",
    "name": "transferDetails",
    "components": [{
      "type": "address",
      "name": "to"
    }, {
      "type": "uint256",
      "name": "requestedAmount"
    }]
  }, {
    "type": "address",
    "name": "owner"
  }, {
    "type": "bytes32",
    "name": "witness"
  }, {
    "type": "string",
    "name": "witnessTypeString"
  }, {
    "type": "bytes",
    "name": "signature"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "tuple[]",
    "name": "transferDetails",
    "components": [{
      "type": "address",
      "name": "from"
    }, {
      "type": "address",
      "name": "to"
    }, {
      "type": "uint160",
      "name": "amount"
    }, {
      "type": "address",
      "name": "token"
    }]
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferFrom",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "from"
  }, {
    "type": "address",
    "name": "to"
  }, {
    "type": "uint160",
    "name": "amount"
  }, {
    "type": "address",
    "name": "token"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}];
const Pool = [{
  "type": "error",
  "name": "AI",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "AS",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "F0",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "F1",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "I",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "IIA",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "L",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "LO",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "LOK",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "M0",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "M1",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NP",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "OLD",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "R",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "T",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TF",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TLM",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TLU",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TUM",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Burn",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "int24",
    "name": "tickLower",
    "indexed": true
  }, {
    "type": "int24",
    "name": "tickUpper",
    "indexed": true
  }, {
    "type": "uint128",
    "name": "amount"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Collect",
  "inputs": [{
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "address",
    "name": "recipient"
  }, {
    "type": "int24",
    "name": "tickLower",
    "indexed": true
  }, {
    "type": "int24",
    "name": "tickUpper",
    "indexed": true
  }, {
    "type": "uint128",
    "name": "amount0"
  }, {
    "type": "uint128",
    "name": "amount1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "CollectProtocol",
  "inputs": [{
    "type": "address",
    "name": "sender",
    "indexed": true
  }, {
    "type": "address",
    "name": "recipient",
    "indexed": true
  }, {
    "type": "uint128",
    "name": "amount0"
  }, {
    "type": "uint128",
    "name": "amount1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Flash",
  "inputs": [{
    "type": "address",
    "name": "sender",
    "indexed": true
  }, {
    "type": "address",
    "name": "recipient",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }, {
    "type": "uint256",
    "name": "paid0"
  }, {
    "type": "uint256",
    "name": "paid1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "IncreaseObservationCardinalityNext",
  "inputs": [{
    "type": "uint16",
    "name": "observationCardinalityNextOld"
  }, {
    "type": "uint16",
    "name": "observationCardinalityNextNew"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Initialize",
  "inputs": [{
    "type": "uint160",
    "name": "sqrtPriceX96"
  }, {
    "type": "int24",
    "name": "tick"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Initialized",
  "inputs": [{
    "type": "uint8",
    "name": "version"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Mint",
  "inputs": [{
    "type": "address",
    "name": "sender"
  }, {
    "type": "address",
    "name": "owner",
    "indexed": true
  }, {
    "type": "int24",
    "name": "tickLower",
    "indexed": true
  }, {
    "type": "int24",
    "name": "tickUpper",
    "indexed": true
  }, {
    "type": "uint128",
    "name": "amount"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "SetFeeProtocol",
  "inputs": [{
    "type": "uint8",
    "name": "feeProtocol0Old"
  }, {
    "type": "uint8",
    "name": "feeProtocol1Old"
  }, {
    "type": "uint8",
    "name": "feeProtocol0New"
  }, {
    "type": "uint8",
    "name": "feeProtocol1New"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Swap",
  "inputs": [{
    "type": "address",
    "name": "sender",
    "indexed": true
  }, {
    "type": "address",
    "name": "recipient",
    "indexed": true
  }, {
    "type": "int256",
    "name": "amount0"
  }, {
    "type": "int256",
    "name": "amount1"
  }, {
    "type": "uint160",
    "name": "sqrtPriceX96"
  }, {
    "type": "uint128",
    "name": "liquidity"
  }, {
    "type": "int24",
    "name": "tick"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "__UniswapV3PoolUpgradeable_init",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "factory_"
  }, {
    "type": "address",
    "name": "token0_"
  }, {
    "type": "address",
    "name": "token1_"
  }, {
    "type": "uint24",
    "name": "fee_"
  }, {
    "type": "int24",
    "name": "tickSpacing_"
  }, {
    "type": "uint16",
    "name": "observationCardinalityNext_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "burn",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "int24",
    "name": "tickLower"
  }, {
    "type": "int24",
    "name": "tickUpper"
  }, {
    "type": "uint128",
    "name": "amount"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "collect",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "recipient"
  }, {
    "type": "int24",
    "name": "tickLower"
  }, {
    "type": "int24",
    "name": "tickUpper"
  }, {
    "type": "uint128",
    "name": "amount0Requested"
  }, {
    "type": "uint128",
    "name": "amount1Requested"
  }],
  "outputs": [{
    "type": "uint128",
    "name": "amount0"
  }, {
    "type": "uint128",
    "name": "amount1"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "collectProtocol",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "recipient"
  }, {
    "type": "uint128",
    "name": "amount0Requested"
  }, {
    "type": "uint128",
    "name": "amount1Requested"
  }],
  "outputs": [{
    "type": "uint128",
    "name": "amount0"
  }, {
    "type": "uint128",
    "name": "amount1"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "distributeRewards",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "rewardsAmount"
  }, {
    "type": "bool",
    "name": "isToken0"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "factory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "fee",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint24"
  }]
}, {
  "type": "function",
  "name": "feeGrowthGlobal0X128",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "feeGrowthGlobal1X128",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "flash",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "recipient"
  }, {
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "increaseObservationCardinalityNext",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint16",
    "name": "observationCardinalityNext"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "initialize",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint160",
    "name": "sqrtPriceX96"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "liquidity",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint128"
  }]
}, {
  "type": "function",
  "name": "maxLiquidityPerTick",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint128"
  }]
}, {
  "type": "function",
  "name": "mint",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "recipient"
  }, {
    "type": "int24",
    "name": "tickLower"
  }, {
    "type": "int24",
    "name": "tickUpper"
  }, {
    "type": "uint128",
    "name": "amount"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "amount0"
  }, {
    "type": "uint256",
    "name": "amount1"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "observations",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "uint32",
    "name": "blockTimestamp"
  }, {
    "type": "int56",
    "name": "tickCumulative"
  }, {
    "type": "uint160",
    "name": "secondsPerLiquidityCumulativeX128"
  }, {
    "type": "bool",
    "name": "initialized"
  }]
}, {
  "type": "function",
  "name": "observe",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint32[]",
    "name": "secondsAgos"
  }],
  "outputs": [{
    "type": "int56[]",
    "name": "tickCumulatives"
  }, {
    "type": "uint160[]",
    "name": "secondsPerLiquidityCumulativeX128s"
  }]
}, {
  "type": "function",
  "name": "positions",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes32"
  }],
  "outputs": [{
    "type": "uint128",
    "name": "liquidity"
  }, {
    "type": "uint256",
    "name": "feeGrowthInside0LastX128"
  }, {
    "type": "uint256",
    "name": "feeGrowthInside1LastX128"
  }, {
    "type": "uint128",
    "name": "tokensOwed0"
  }, {
    "type": "uint128",
    "name": "tokensOwed1"
  }]
}, {
  "type": "function",
  "name": "protocolFees",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint128",
    "name": "token0"
  }, {
    "type": "uint128",
    "name": "token1"
  }]
}, {
  "type": "function",
  "name": "setFeeProtocol",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint8",
    "name": "feeProtocol0"
  }, {
    "type": "uint8",
    "name": "feeProtocol1"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "slot0",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint160",
    "name": "sqrtPriceX96"
  }, {
    "type": "int24",
    "name": "tick"
  }, {
    "type": "uint16",
    "name": "observationIndex"
  }, {
    "type": "uint16",
    "name": "observationCardinality"
  }, {
    "type": "uint16",
    "name": "observationCardinalityNext"
  }, {
    "type": "uint8",
    "name": "feeProtocol"
  }, {
    "type": "bool",
    "name": "unlocked"
  }]
}, {
  "type": "function",
  "name": "snapshotCumulativesInside",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "int24",
    "name": "tickLower"
  }, {
    "type": "int24",
    "name": "tickUpper"
  }],
  "outputs": [{
    "type": "int56",
    "name": "tickCumulativeInside"
  }, {
    "type": "uint160",
    "name": "secondsPerLiquidityInsideX128"
  }, {
    "type": "uint32",
    "name": "secondsInside"
  }]
}, {
  "type": "function",
  "name": "swap",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "recipient"
  }, {
    "type": "bool",
    "name": "zeroForOne"
  }, {
    "type": "int256",
    "name": "amountSpecified"
  }, {
    "type": "uint160",
    "name": "sqrtPriceLimitX96"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [{
    "type": "int256",
    "name": "amount0"
  }, {
    "type": "int256",
    "name": "amount1"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "tickBitmap",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "int16"
  }],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "tickSpacing",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "int24"
  }]
}, {
  "type": "function",
  "name": "ticks",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "int24"
  }],
  "outputs": [{
    "type": "uint128",
    "name": "liquidityGross"
  }, {
    "type": "int128",
    "name": "liquidityNet"
  }, {
    "type": "uint256",
    "name": "feeGrowthOutside0X128"
  }, {
    "type": "uint256",
    "name": "feeGrowthOutside1X128"
  }, {
    "type": "int56",
    "name": "tickCumulativeOutside"
  }, {
    "type": "uint160",
    "name": "secondsPerLiquidityOutsideX128"
  }, {
    "type": "uint32",
    "name": "secondsOutside"
  }, {
    "type": "bool",
    "name": "initialized"
  }]
}, {
  "type": "function",
  "name": "token0",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "token1",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}];
const PoolRouter = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "positionManager_"
  }, {
    "type": "address",
    "name": "router_"
  }, {
    "type": "address",
    "name": "quoter_"
  }, {
    "type": "address",
    "name": "nftxVaultFactory_"
  }, {
    "type": "address",
    "name": "PERMIT2_"
  }, {
    "type": "uint256",
    "name": "lpTimelock_"
  }, {
    "type": "uint256",
    "name": "earlyWithdrawPenaltyInWei_"
  }, {
    "type": "uint256",
    "name": "vTokenDustThreshold_"
  }, {
    "type": "address",
    "name": "inventoryStaking_"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "ETHValueLowerThanMin",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientVTokens",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidEarlyWithdrawPenalty",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NoETHFundsNeeded",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotNFTOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotPositionOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnableToSendETH",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroLPTimelock",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "AddLiquidity",
  "inputs": [{
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "vTokensAmount"
  }, {
    "type": "uint256[]",
    "name": "nftIds"
  }, {
    "type": "address",
    "name": "pool"
  }, {
    "type": "address",
    "name": "recipient"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "BuyNFTs",
  "inputs": [{
    "type": "uint256",
    "name": "nftCount"
  }, {
    "type": "uint256",
    "name": "ethSpent"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "IncreaseLiquidity",
  "inputs": [{
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "vTokensAmount"
  }, {
    "type": "uint256[]",
    "name": "nftIds"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "RemoveLiquidity",
  "inputs": [{
    "type": "uint256",
    "name": "positionId",
    "indexed": true
  }, {
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "vTokenAmt"
  }, {
    "type": "uint256",
    "name": "wethAmt"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "SellNFTs",
  "inputs": [{
    "type": "uint256",
    "name": "nftCount"
  }, {
    "type": "uint256",
    "name": "ethReceived"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "PERMIT2",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "WETH",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "addLiquidity",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256",
      "name": "vTokensAmount"
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256[]",
      "name": "nftAmounts"
    }, {
      "type": "int24",
      "name": "tickLower"
    }, {
      "type": "int24",
      "name": "tickUpper"
    }, {
      "type": "uint24",
      "name": "fee"
    }, {
      "type": "uint160",
      "name": "sqrtPriceX96"
    }, {
      "type": "uint256",
      "name": "vTokenMin"
    }, {
      "type": "uint256",
      "name": "wethMin"
    }, {
      "type": "uint256",
      "name": "deadline"
    }, {
      "type": "bool",
      "name": "forceTimelock"
    }, {
      "type": "address",
      "name": "recipient"
    }]
  }],
  "outputs": [{
    "type": "uint256",
    "name": "positionId"
  }]
}, {
  "type": "function",
  "name": "addLiquidityWithPermit2",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256",
      "name": "vTokensAmount"
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256[]",
      "name": "nftAmounts"
    }, {
      "type": "int24",
      "name": "tickLower"
    }, {
      "type": "int24",
      "name": "tickUpper"
    }, {
      "type": "uint24",
      "name": "fee"
    }, {
      "type": "uint160",
      "name": "sqrtPriceX96"
    }, {
      "type": "uint256",
      "name": "vTokenMin"
    }, {
      "type": "uint256",
      "name": "wethMin"
    }, {
      "type": "uint256",
      "name": "deadline"
    }, {
      "type": "bool",
      "name": "forceTimelock"
    }, {
      "type": "address",
      "name": "recipient"
    }]
  }, {
    "type": "bytes",
    "name": "encodedPermit2"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "positionId"
  }]
}, {
  "type": "function",
  "name": "buyNFTs",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256",
      "name": "vTokenPremiumLimit"
    }, {
      "type": "uint256",
      "name": "deadline"
    }, {
      "type": "uint24",
      "name": "fee"
    }, {
      "type": "uint160",
      "name": "sqrtPriceLimitX96"
    }]
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "computePool",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "vToken_"
  }, {
    "type": "uint24",
    "name": "fee"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "earlyWithdrawPenaltyInWei",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "getPool",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "vToken_"
  }, {
    "type": "uint24",
    "name": "fee"
  }],
  "outputs": [{
    "type": "address",
    "name": "pool"
  }]
}, {
  "type": "function",
  "name": "getPoolExists",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint24",
    "name": "fee"
  }],
  "outputs": [{
    "type": "address",
    "name": "pool"
  }, {
    "type": "bool",
    "name": "exists"
  }]
}, {
  "type": "function",
  "name": "getPoolExists",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "vToken_"
  }, {
    "type": "uint24",
    "name": "fee"
  }],
  "outputs": [{
    "type": "address",
    "name": "pool"
  }, {
    "type": "bool",
    "name": "exists"
  }]
}, {
  "type": "function",
  "name": "increaseLiquidity",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "positionId"
    }, {
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256",
      "name": "vTokensAmount"
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256[]",
      "name": "nftAmounts"
    }, {
      "type": "uint256",
      "name": "vTokenMin"
    }, {
      "type": "uint256",
      "name": "wethMin"
    }, {
      "type": "uint256",
      "name": "deadline"
    }, {
      "type": "bool",
      "name": "forceTimelock"
    }]
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "increaseLiquidityWithPermit2",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "positionId"
    }, {
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256",
      "name": "vTokensAmount"
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256[]",
      "name": "nftAmounts"
    }, {
      "type": "uint256",
      "name": "vTokenMin"
    }, {
      "type": "uint256",
      "name": "wethMin"
    }, {
      "type": "uint256",
      "name": "deadline"
    }, {
      "type": "bool",
      "name": "forceTimelock"
    }]
  }, {
    "type": "bytes",
    "name": "encodedPermit2"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "inventoryStaking",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "isVToken0",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "vtoken"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "lpTimelock",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "nftxVaultFactory",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "onERC1155BatchReceived",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256[]"
  }, {
    "type": "uint256[]"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC1155Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "onERC721Received",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "positionManager",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "quoteBuyNFTs",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "vtoken"
  }, {
    "type": "uint256",
    "name": "nftsCount"
  }, {
    "type": "uint24",
    "name": "fee"
  }, {
    "type": "uint160",
    "name": "sqrtPriceLimitX96"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "ethRequired"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "quoter",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "removeLiquidity",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "positionId"
    }, {
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256",
      "name": "vTokenPremiumLimit"
    }, {
      "type": "uint128",
      "name": "liquidity"
    }, {
      "type": "uint256",
      "name": "amount0Min"
    }, {
      "type": "uint256",
      "name": "amount1Min"
    }, {
      "type": "uint256",
      "name": "deadline"
    }]
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "rescueTokens",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "token"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "router",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "sellNFTs",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "uint256",
      "name": "vaultId"
    }, {
      "type": "uint256[]",
      "name": "nftIds"
    }, {
      "type": "uint256[]",
      "name": "nftAmounts"
    }, {
      "type": "uint256",
      "name": "deadline"
    }, {
      "type": "uint24",
      "name": "fee"
    }, {
      "type": "uint256",
      "name": "amountOutMinimum"
    }, {
      "type": "uint160",
      "name": "sqrtPriceLimitX96"
    }]
  }],
  "outputs": [{
    "type": "uint256",
    "name": "wethReceived"
  }]
}, {
  "type": "function",
  "name": "setEarlyWithdrawPenalty",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "earlyWithdrawPenaltyInWei_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setLpTimelock",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lpTimelock_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setVTokenDustThreshold",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vTokenDustThreshold_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "vTokenDustThreshold",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}];
const UniversalRouter = [{
  "type": "constructor",
  "payable": false,
  "inputs": [{
    "type": "tuple",
    "name": "params",
    "components": [{
      "type": "address",
      "name": "permit2"
    }, {
      "type": "address",
      "name": "weth9"
    }, {
      "type": "address",
      "name": "seaportV1_5"
    }, {
      "type": "address",
      "name": "seaportV1_4"
    }, {
      "type": "address",
      "name": "openseaConduit"
    }, {
      "type": "address",
      "name": "nftxZap"
    }, {
      "type": "address",
      "name": "x2y2"
    }, {
      "type": "address",
      "name": "foundation"
    }, {
      "type": "address",
      "name": "sudoswap"
    }, {
      "type": "address",
      "name": "elementMarket"
    }, {
      "type": "address",
      "name": "nft20Zap"
    }, {
      "type": "address",
      "name": "cryptopunks"
    }, {
      "type": "address",
      "name": "looksRareV2"
    }, {
      "type": "address",
      "name": "routerRewardsDistributor"
    }, {
      "type": "address",
      "name": "looksRareRewardsDistributor"
    }, {
      "type": "address",
      "name": "looksRareToken"
    }, {
      "type": "address",
      "name": "v2Factory"
    }, {
      "type": "address",
      "name": "v3Factory"
    }, {
      "type": "bytes32",
      "name": "pairInitCodeHash"
    }, {
      "type": "bytes32",
      "name": "poolInitCodeHash"
    }]
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "error",
  "name": "BalanceTooLow",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "BuyPunkFailed",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ContractLocked",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ETHNotAccepted",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ExecutionFailed",
  "inputs": [{
    "type": "uint256",
    "name": "commandIndex"
  }, {
    "type": "bytes",
    "name": "message"
  }],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "FromAddressIsNotOwner",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientETH",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InsufficientToken",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidBips",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidCommandType",
  "inputs": [{
    "type": "uint256",
    "name": "commandType"
  }],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidOwnerERC1155",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidOwnerERC721",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidPath",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidReserves",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "InvalidSpender",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "LengthMismatch",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "SliceOutOfBounds",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "TransactionDeadlinePassed",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnableToClaim",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "UnsafeCast",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V2InvalidPath",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V2TooLittleReceived",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V2TooMuchRequested",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3InvalidAmountOut",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3InvalidCaller",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3InvalidSwap",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3TooLittleReceived",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "V3TooMuchRequested",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "RewardsSent",
  "inputs": [{
    "type": "uint256",
    "name": "amount"
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "collectRewards",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "bytes",
    "name": "looksRareClaim"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "execute",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "bytes",
    "name": "commands"
  }, {
    "type": "bytes[]",
    "name": "inputs"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "execute",
  "constant": false,
  "stateMutability": "payable",
  "payable": true,
  "inputs": [{
    "type": "bytes",
    "name": "commands"
  }, {
    "type": "bytes[]",
    "name": "inputs"
  }, {
    "type": "uint256",
    "name": "deadline"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "onERC1155BatchReceived",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256[]"
  }, {
    "type": "uint256[]"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }]
}, {
  "type": "function",
  "name": "onERC1155Received",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }]
}, {
  "type": "function",
  "name": "onERC721Received",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "address"
  }, {
    "type": "address"
  }, {
    "type": "uint256"
  }, {
    "type": "bytes"
  }],
  "outputs": [{
    "type": "bytes4"
  }]
}, {
  "type": "function",
  "name": "supportsInterface",
  "constant": true,
  "stateMutability": "pure",
  "payable": false,
  "inputs": [{
    "type": "bytes4",
    "name": "interfaceId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "uniswapV3SwapCallback",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "int256",
    "name": "amount0Delta"
  }, {
    "type": "int256",
    "name": "amount1Delta"
  }, {
    "type": "bytes",
    "name": "data"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}];
const VaultFactory = [{
  "type": "error",
  "name": "CallerIsNotVault",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ChildImplementationIsNotAContract",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "DepositorPremiumShareExceedsLimit",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "FeeDistributorNotSet",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "FeeExceedsLimit",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NFTInventoryExceeded",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "NotGuardian",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "Paused",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "T",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "VaultImplementationNotSet",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroAddress",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroAmountRequested",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "error",
  "name": "ZeroTwapInterval",
  "inputs": [],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "DisableVaultFees",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "FeeExclusion",
  "inputs": [{
    "type": "address",
    "name": "feeExcluded"
  }, {
    "type": "bool",
    "name": "excluded"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Initialized",
  "inputs": [{
    "type": "uint8",
    "name": "version"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewDepositorPremiumShare",
  "inputs": [{
    "type": "uint256",
    "name": "depositorPremiumShare"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewEligibilityManager",
  "inputs": [{
    "type": "address",
    "name": "oldEligManager"
  }, {
    "type": "address",
    "name": "newEligManager"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewFeeDistributor",
  "inputs": [{
    "type": "address",
    "name": "oldDistributor"
  }, {
    "type": "address",
    "name": "newDistributor"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewPremiumDuration",
  "inputs": [{
    "type": "uint256",
    "name": "premiumDuration"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewPremiumMax",
  "inputs": [{
    "type": "uint256",
    "name": "premiumMax"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewTwapInterval",
  "inputs": [{
    "type": "uint32",
    "name": "twapInterval"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewVault",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId",
    "indexed": true
  }, {
    "type": "address",
    "name": "vaultAddress"
  }, {
    "type": "address",
    "name": "assetAddress"
  }, {
    "type": "string",
    "name": "name"
  }, {
    "type": "string",
    "name": "symbol"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "NewZapContract",
  "inputs": [{
    "type": "address",
    "name": "oldZap"
  }, {
    "type": "address",
    "name": "newZap"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "OwnershipTransferred",
  "inputs": [{
    "type": "address",
    "name": "previousOwner",
    "indexed": true
  }, {
    "type": "address",
    "name": "newOwner",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "SetIsGuardian",
  "inputs": [{
    "type": "address",
    "name": "addr"
  }, {
    "type": "bool",
    "name": "isGuardian"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "SetPaused",
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }, {
    "type": "bool",
    "name": "paused"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "UpdateFactoryFees",
  "inputs": [{
    "type": "uint256",
    "name": "mintFee"
  }, {
    "type": "uint256",
    "name": "redeemFee"
  }, {
    "type": "uint256",
    "name": "swapFee"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "UpdateVaultFees",
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "mintFee"
  }, {
    "type": "uint256",
    "name": "redeemFee"
  }, {
    "type": "uint256",
    "name": "swapFee"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "UpdatedZapContract",
  "inputs": [{
    "type": "address",
    "name": "zap"
  }, {
    "type": "bool",
    "name": "excluded"
  }],
  "stateMutability": "view"
}, {
  "type": "event",
  "anonymous": false,
  "name": "Upgraded",
  "inputs": [{
    "type": "address",
    "name": "beaconImplementation",
    "indexed": true
  }],
  "stateMutability": "view"
}, {
  "type": "function",
  "name": "__NFTXVaultFactory_init",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "vaultImpl"
  }, {
    "type": "uint32",
    "name": "twapInterval_"
  }, {
    "type": "uint256",
    "name": "premiumDuration_"
  }, {
    "type": "uint256",
    "name": "premiumMax_"
  }, {
    "type": "uint256",
    "name": "depositorPremiumShare_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "__UpgradeableBeacon__init",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "beaconImplementation_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "allVaults",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address[]"
  }]
}, {
  "type": "function",
  "name": "computeVaultAddress",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "assetAddress"
  }, {
    "type": "string",
    "name": "name"
  }, {
    "type": "string",
    "name": "symbol"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "createVault",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "string",
    "name": "name"
  }, {
    "type": "string",
    "name": "symbol"
  }, {
    "type": "address",
    "name": "assetAddress"
  }, {
    "type": "bool",
    "name": "is1155"
  }, {
    "type": "bool",
    "name": "allowAllItems"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "vaultId"
  }],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "depositorPremiumShare",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "disableVaultFees",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "eligibilityManager",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "excludedFromFees",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "factoryMintFee",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint64"
  }]
}, {
  "type": "function",
  "name": "factoryRedeemFee",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint64"
  }]
}, {
  "type": "function",
  "name": "factorySwapFee",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint64"
  }]
}, {
  "type": "function",
  "name": "feeDistributor",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "getTwapX96",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "pool"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "priceX96"
  }]
}, {
  "type": "function",
  "name": "getVTokenPremium1155",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }, {
    "type": "uint256",
    "name": "amount"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "totalPremium"
  }, {
    "type": "uint256[]",
    "name": "premiums"
  }, {
    "type": "address[]",
    "name": "depositors"
  }]
}, {
  "type": "function",
  "name": "getVTokenPremium721",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "tokenId"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "premium"
  }, {
    "type": "address",
    "name": "depositor"
  }]
}, {
  "type": "function",
  "name": "implementation",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "isGuardian",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "isLocked",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "isPaused",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256"
  }],
  "outputs": [{
    "type": "bool"
  }]
}, {
  "type": "function",
  "name": "numVaults",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "onlyOwnerIfPaused",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }],
  "outputs": []
}, {
  "type": "function",
  "name": "owner",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "pause",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "premiumDuration",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "premiumMax",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint256"
  }]
}, {
  "type": "function",
  "name": "renounceOwnership",
  "constant": false,
  "payable": false,
  "inputs": [],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setDepositorPremiumShare",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "depositorPremiumShare_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setEligibilityManager",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "eligibilityManager_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setFactoryFees",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "mintFee"
  }, {
    "type": "uint256",
    "name": "redeemFee"
  }, {
    "type": "uint256",
    "name": "swapFee"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setFeeDistributor",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "feeDistributor_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setFeeExclusion",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "excludedAddr"
  }, {
    "type": "bool",
    "name": "excluded"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setIsGuardian",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "addr"
  }, {
    "type": "bool",
    "name": "_isGuardian"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setPremiumDuration",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "premiumDuration_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setPremiumMax",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "premiumMax_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setTwapInterval",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint32",
    "name": "twapInterval_"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "setVaultFees",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }, {
    "type": "uint256",
    "name": "mintFee"
  }, {
    "type": "uint256",
    "name": "redeemFee"
  }, {
    "type": "uint256",
    "name": "swapFee"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "transferOwnership",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newOwner"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "twapInterval",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [],
  "outputs": [{
    "type": "uint32"
  }]
}, {
  "type": "function",
  "name": "unpause",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "lockId"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "upgradeBeaconTo",
  "constant": false,
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "newBeaconImplementation"
  }],
  "outputs": [],
  "stateMutability": "nonpayable"
}, {
  "type": "function",
  "name": "vault",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }],
  "outputs": [{
    "type": "address"
  }]
}, {
  "type": "function",
  "name": "vaultFees",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "uint256",
    "name": "vaultId"
  }],
  "outputs": [{
    "type": "uint256",
    "name": "mintFee"
  }, {
    "type": "uint256",
    "name": "redeemFee"
  }, {
    "type": "uint256",
    "name": "swapFee"
  }]
}, {
  "type": "function",
  "name": "vaultsForAsset",
  "constant": true,
  "stateMutability": "view",
  "payable": false,
  "inputs": [{
    "type": "address",
    "name": "assetAddress"
  }],
  "outputs": [{
    "type": "address[]"
  }]
}];

export { AMMFactory, BaseRegistrarImplementation, CreateVaultZap, CryptoPunks, ERC20, ERC721, InventoryStaking, KittyCore, MarketplaceZap, NFTXENSMerkleEligibility, NFTXEligibility, NFTXVaultUpgradeable, NftxRouter, NonfungiblePositionManager, Permit2, Pool, PoolRouter, UniversalRouter, VaultFactory };
